import { CardImg, Col, Row, Table } from "reactstrap"
import React, { useState } from "react"
import { arrayMove, change, Field, formValueSelector } from "redux-form"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"
import { CustomImageField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import ModalComponent from "components/Modals"
import ListItemPopup from "./listItemPopup"
import { connect } from "react-redux"
import { hideListItemPopup, openListItemPopup } from "store/actions"

const renderListItemForm = ({
  fields,
  openListItemPopup,
  isListItemPopupOpen,
  hideListItemPopup,
  change,
  listItems,
  arrayMove,
}) => {
  const [selectedListItem, setSelectedListItem] = useState()
  const [selectedListItemIndex, setSelectedListItemIndex] = useState()

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      arrayMove("list_form.listItems", fromIndex, toIndex)
    },
    nodeSelector: "div.row",
    handleSelector: "div.row",
    lineClassName: "dragDropLine",
  }

  return (
    <React.Fragment>
      <ReactDragListView {...dragProps}>
        <div className="table-responsive">
          <Table className="project-list-table table-nowrap align-middle table-borderless">
            <thead>
              <tr>
                <th scope="col">Order</th>
                <th scope="col" style={{ textAlign: "center" }}>
                  Image
                </th>
                <th scope="col">List Item Title</th>
                <th scope="col">Add More Info</th>
              </tr>
            </thead>
            <tbody>
              {fields.map((listItem, index) => {
                return (
                  <tr key={index}>
                    <td>
                      <i
                        className="bx bx-sm bx-menu"
                        style={{
                          cursor: "pointer",
                        }}
                      />
                    </td>
                    <td style={{ textAlign: "center", maxWidth: "120px" }}>
                      {listItems &&
                        listItems[index]?.image &&
                        listItems[index]?.image?.editedImage && (
                          <div className="py-1">
                            <img
                              src={listItems[index]?.image?.editedImage}
                              style={{
                                width: "auto",
                                maxHeight: "100px",
                                maxWidth: "100%",
                              }}
                            />
                          </div>
                        )}
                      <Field
                        name={`${listItem}.image`}
                        component={CustomImageField}
                        buttonSize="sm"
                        onDelete={() => {
                          change(`list_form.${listItem}.deleteImage`, true)
                        }}
                      />
                    </td>
                    <td>
                      <Field name={`${listItem}.line1`} component={TextField} />
                      <Field name={`${listItem}.line2`} component={TextField} />
                      <Field name={`${listItem}.line3`} component={TextField} />
                    </td>
                    <td>
                      <div className="d-flex justify-content-between flex-nowrap align-items-center">
                        <i
                          className="bx bx-md bxs-plus-circle"
                          style={{ color: "#34c38f", cursor: "pointer" }}
                          onClick={() => {
                            setSelectedListItem(listItem)
                            setSelectedListItemIndex(index)
                            openListItemPopup()
                          }}
                        />
                        {index > 0 && (
                          <i
                            className="bx bx-sm bx-x"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              fields.remove(index)
                            }}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </ReactDragListView>
      <ModalComponent
        title="List Item Popup"
        open={isListItemPopupOpen}
        onClose={hideListItemPopup}
        size="lg"
      >
        <ListItemPopup
          closeHandler={hideListItemPopup}
          listItem={selectedListItem}
          itemIndex={selectedListItemIndex}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST)

const mapStateToProps = state => ({
  isListItemPopupOpen: state.List.isListItemPopupOpen,
  listItems: selector(state, "list_form.listItems"),
})

const mapDispatchToProps = dispatch => ({
  openListItemPopup: () => dispatch(openListItemPopup()),
  hideListItemPopup: () => dispatch(hideListItemPopup()),
  change: (field, value) => dispatch(change(FORM_NAMES.LIST, field, value)),
  arrayMove: (field, from, to) =>
    dispatch(arrayMove(FORM_NAMES.LIST, `${field}`, from, to)),
})

export default connect(mapStateToProps, mapDispatchToProps)(renderListItemForm)
